import "../../styles/Various.css"

import React, { useEffect, useState } from "react"
import {
  faChevronLeft,
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "react-router-dom"
import SubEspImg from "./SubEspImg"
import seedSubEsperienze from "../../data/seedSubEsperienze"

const SubEsperienze = ({ subEsp }) => {
  useEffect(() => {
    document.title = subEsp.title
  }, [subEsp.title])

  const findNext = (id) => {
    let i = seedSubEsperienze.indexOf(id)
    i++
    i = i % seedSubEsperienze.length
    return seedSubEsperienze[i]
  }

  const findPrev = (id) => {
    let i = seedSubEsperienze.indexOf(id)
    if (i === 0) i = seedSubEsperienze.length
    i--
    return seedSubEsperienze[i]
  }

  let next = findNext(subEsp)
  let prev = findPrev(subEsp)

  const subEspImgs = subEsp.imgs.map((img, idx) => (
    <SubEspImg
      path1={img.path1}
      path2={img.path2}
      description={img.description}
      location={img.location}
      link={img.link}
      key={img.path1.split("/").pop().slice(0, -4)}
    />
  ))
  let category = subEsp.category.toLowerCase().replace(/ /g, "-")

  const [view, setView] = useState("galleria")
  return (
    <div className="SubEsp">
      <title>{subEsp.title}</title>
      <section className="SubEsp-title">
        <h1 className="pb-5 d-flex flex-wrap">
          <Link to={`/esperienze/${category}`}>
            <FontAwesomeIcon icon={faLongArrowAltLeft} className="me-2" />
            {subEsp.category}
          </Link>
          /{subEsp.title}
        </h1>
      </section>

      <section className="SubEsp-img">
        {subEsp.id === "cammini" ? (
          <>
            <section className="mb-3">
              <div
                className="btn-group"
                role="group"
                aria-label="Visualizzazione"
              >
                <button
                  type="button"
                  className={
                    view === "galleria"
                      ? "btn btn-primary"
                      : "btn btn-outline-primary"
                  }
                  onClick={() => setView("galleria")}
                >
                  Esempi
                </button>
                <button
                  type="button"
                  className={
                    view === "mappa"
                      ? "btn btn-primary"
                      : "btn btn-outline-primary"
                  }
                  onClick={() => setView("mappa")}
                >
                  Mappa
                </button>
              </div>
            </section>

            <div className="row">
              {view === "galleria" ? (
                subEspImgs
              ) : (
                <div className="col-12">
                  <div style={{ width: "100%" }}>
                    <iframe
                      title="Mappa percorsi"
                      src="https://www.pibinko.org/map/iris-ecoturismo/#8/43.52/10.87"
                      style={{
                        width: "100%",
                        height: "600px",
                        border: "0",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="row">{subEspImgs}</div>
        )}
      </section>
      <section className="SubEsp-change-page py-4">
        <Link
          className="float-start btn btn-light"
          to={`/esperienze/${category}/${prev.id}`}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
          <span className="d-none d-sm-inline-block">{prev.title}</span>
        </Link>
        <Link
          className="float-end btn btn-light"
          to={`/esperienze/${category}/${next.id}`}
        >
          <span className="d-none d-sm-inline-block">{next.title}</span>
          <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
        </Link>
      </section>
    </div>
  )
}

export default SubEsperienze
